module.exports = __webpack_public_path__ + "static/media/alexander-kitov.355178c5.png";